import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    isLoading: false,
    errors: "",
    data: [],
};

const userSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        errors: (state, action) => {
            state.errors = action.payload;
        },
        setData: (state, action) => {
            state.data = action.payload;
        },
    },
});

export const { errors, setData,setLoading} = userSlice.actions;
export default userSlice.reducer;